import React from 'react';

type Props = {
  markup: object | undefined;
};

export const SeoLayout: React.FC<Props> = ({ markup }) => {
  return (
    markup && (
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(markup),
        }}
      />
    )
  );
};
